import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { VoyageService } from '../../services/voyage.service';
import { PortService } from 'src/app/core-services/port.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Port } from 'src/app/models/Port';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-voyage-performance-level3',
  templateUrl: './voyage-performance-level3.component.html',
  styleUrls: ['./voyage-performance-level3.component.css']
})
export class VoyagePerformanceLevel3Component implements OnInit {
  dataSource: Object;
  portsData: Port[] = [];
  currentDate: Date;
  currentYear: number;
  yearsDataList: any[] = [];
  submitted: boolean = false;
  noOfVessels: any;
  frequencyData: any;
  noOfPortCalls: any;
  voyageLength: any;
  companyName: string;
  day: number[] = [];
  companydata: number[] = [];
  fromPortId: number;
  toPortId: number;
  MonthId:number;
  searchDate: string = '';
  isFirstTime: boolean = true;
  options: any;
  voyageform: FormGroup;
  mothData: any[] = [];
  stateParams: any;
  shippingLineId: number;   
  SelectedMonthId: number;
  constructor(private fb: FormBuilder,private portService: PortService, private toastr: ToastrService,
    private voyageService: VoyageService, private router: Router,private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute) {
      
      this.activatedRoute.paramMap.subscribe((params: any) => {
        this.stateParams = params.params;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      });

     }

  ngOnInit() {
    this.voyageform = this.fb.group({
      fromPort: ["", Validators.required],
      toPort: ["", Validators.required],
      month: [""],
      year: ["", Validators.required]
    });
    if (this.stateParams != null && this.stateParams.fromPortId > 0 && this.stateParams.monthId && this.stateParams.toPortId > 0 && this.stateParams.year != null && this.stateParams.year != '') {
      this.fromPortId = parseInt(this.stateParams.fromPortId);
      this.toPortId = parseInt(this.stateParams.toPortId);
      this.MonthId = parseInt(this.stateParams.monthId);
      this.searchDate = this.stateParams.year;
    }
    this.currentDate = new Date();
    this.currentYear = this.currentDate.getUTCFullYear();
    for (let year = this.currentYear; year <= this.currentYear + 50; year++) {
      if (year != null) {
        var yearData =
        {
          value: year.toString(),
          viewValue: year.toString(),
        };
        this.yearsDataList.push(yearData);
      }
    }
    if (this.stateParams != null && this.stateParams != undefined) {
      var selectedYear = {
        value: this.stateParams.year,
        viewValue: this.stateParams.year
      }
      this.voyageform.controls.year.setValue(selectedYear);
    }
    this.getPortDatafordropdown();
    this.getMonthLookUpData();
    this.getVoyagePerformance();
  }
  getMonthLookUpData() {
    this.voyageService.getMasterLookUpMonth().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.mothData = response.content;
      }
    });
  }

  getPortDatafordropdown() {
    this.portService.GetPortData().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.portsData = response.content;
        if (this.isFirstTime == true) {
          if (this.stateParams != null && this.stateParams != undefined) {
            var fromPort = response.content.filter(x => x.id == this.stateParams.fromPortId);
            var toPort = response.content.filter(x => x.id == this.stateParams.toPortId);
            if (fromPort != null && fromPort.length > 0) {
              this.fromPortId = fromPort[0].id;
              this.voyageform.controls.fromPort.setValue(fromPort[0]);
            }
            if (toPort != null && toPort.length > 0) {
              this.toPortId = toPort[0].id;
              this.voyageform.controls.toPort.setValue(toPort[0]);
            }
          }
          this.isFirstTime = false;
          // this.getVoyagePerformance();
        }
      }
    });
  }
   searchPorts(event, flag) {
    let portName = '';
    if (event != null && event.query != null && event.query != '') {
      if (event.query.length > 2) {
        portName = event.query;
      }
      else {
        this.portsData = [];
      }
    }
    else {
      if (flag == 'from') {
        if (this.voyageform.controls.fromPort.value != null && this.voyageform.controls.fromPort.value != '') {
          portName = this.voyageform.controls.fromPort.value.portName;
        }
      }
      else {
        if (this.voyageform.controls.toPort.value != null && this.voyageform.controls.toPort.value != '') {
          portName = this.voyageform.controls.toPort.value.portName;
        }
      }
    }
    if (event.query != '') {
      var data = {
        PortName: portName
      };
      this.portService.GetPortDataByName(data).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.portsData = response.content;
        }
        else {
          this.portsData = [];
        }
      })
    }
    else {
      this.getPortDatafordropdown();

    }
  }
  getVoyagePerformance() {
    if (this.fromPortId > 0 && this.toPortId > 0 && this.MonthId > 0  && this.searchDate != null && this.searchDate != '') {
      var voyageData = {
        fromPortId: this.fromPortId,
        toPortId: this.toPortId,
        MonthId:this.MonthId,
        searchDate: this.searchDate,
        shippingLineId: parseInt(this.stateParams.id)
      }
      this.spinner.show();
      this.voyageService.getVoyagePerformanceForDayChart(voyageData).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.spinner.hide();
          // bind No of Vessels chart
          if (response.content.noOfVesselsWithShips) {
            let res = response.content;
            this.noOfVessels = [];
            this.companydata = [];            
            this.day = [];

            this.companyName = response.content.noOfVesselsWithShips[0].companyName;
            this.shippingLineId = response.content.noOfVesselsWithShips[0].id;
            if (this.companyName == 'Wallenius Wilhelmsen Ocean') {
              this.companyName = 'WWO';
            }

            response.content.noOfVesselsWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                this.companydata.push(element.noOfVessels);                
                this.day.push(element.day);
              }
            });

            this.noOfVessels = {
              labels: this.day,
              datasets: [
                {
                  lablesfortip: this.companyName,                  
                  label: 'No Of Vessels',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // bind Frequency of shippiingline
          if (response.content.frequencyOfWithShips) {
            let res = response.content.frequencyOfWithShips;
            this.frequencyData = [];
            this.companydata = [];            
            this.day = [];
            response.content.frequencyOfWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {

                this.companydata.push(element.noOfAVGDays);                
                this.day.push(element.day);
              }
            });

            this.frequencyData = {
              labels: this.day,
              datasets: [
                {
                  lablesfortip: this.companyName,                  
                  label: 'Frequency(days betwen sailings)',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // bind No Of port call
          if (response.content.noOfPortCallsWithShips) {
            let res = response.content.noOfPortCallsWithShips;
            this.noOfPortCalls = [];
            this.companydata = [];            
            this.day = [];
            response.content.noOfPortCallsWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companydata.push(element.noOfPortCall);                
                this.day.push(element.day);
              }
            });

            this.noOfPortCalls = {
              labels: this.day,
              datasets: [
                {
                  lablesfortip: this.companyName,                  
                  label: 'No of ports call in voyage',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // Bind Voyage Length
          if (response.content.voyageLengthWithShips) {
            let res = response.content.voyageLengthWithShips;
            this.voyageLength = [];
            this.companydata = [];            
            this.day = [];
            response.content.voyageLengthWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                this.companydata.push(element.noOfAVGDays);                
                this.day.push(element.day);
              }
            });

            this.voyageLength = {
              labels: this.day,
              datasets: [
                {
                  lablesfortip: this.companyName,                  
                  label: 'Voyage length in days',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          this.options = {
            title: {
              display: true,
              text: this.companyName,
              fontSize: 16
            },
            legend: {
              position: 'bottom'
            }
          };
        }
        this.spinner.hide();
      });
    }
  }
  onSearch() {
    this.submitted = true;
    if (this.voyageform.invalid) {
      this.toastr.error("InValid Form, Please select Region and Year.", "Error");
      return;
    }
    else {
      var data = this.voyageform.value;
      if (data != null && (data.fromPort != null && data.fromPort != '') && (data.toPort != null && data.toPort != '') && (data.year != null && data.year != '')) {
        if (data.month != null && data.month != '' && data.month.id > 0) {
          if (data.month.id < 10) {
            this.searchDate = data.year.value + '-' + '0' + data.month.id
          }
          else {
            this.searchDate = data.year.value + '-' + data.month.id
          }

        }
        else {
          if (data.year.value > 0) {
            this.searchDate = data.year.value.toString();
          }

        }

        if (data.fromPort.id > 0 && data.toPort.id > 0) {
          if (data.fromPort.id != data.toPort.id) {
            this.fromPortId = data.fromPort.id;
            this.toPortId = data.toPort.id;
            this.getVoyagePerformance();
          }
          else {
            this.toastr.error("Port should be different.", "Error");
          }
        }
        else {
          this.toastr.error('Incurrect port', 'Erro');
        }
      }
    }
  }
   selectDataOfChart(event) {
    if (event != null && event.element != null && event.element._chart != null && event.element._chart.data != null) {
      if (event.element._chart.data.datasets.length > 0 && event.element._chart.data.datasets[0].monthId != null && event.element._chart.data.datasets[0].monthId.length > 0) {
        if (event.element._index != null && event.element._index >= 0) {
          this.SelectedMonthId = event.element._chart.data.datasets[0].monthId[event.element._index]
          if (this.SelectedMonthId > 0) {
            "voyageperformance/:id/:fromPortId/:toPortId/:monthId/:year"
            let url = '/voyageperformance/' + this.stateParams.id + '/' + this.fromPortId + '/' + this.toPortId + '/' + this.SelectedMonthId + '/' + this.searchDate
            this.router.navigate([url]);
          }
        }
      }
    }
    var data = event;
  }
  }


